<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Services</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create New</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="Rules.required"
                    label="Service Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select
                    v-model="editedItem.is_active"
                    :items="this.activeStatus"
                    item-text="name"
                    item-value="id"
                    :rules="Rules.serviceActive"
                    label="Active Status"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <div v-if="indexData.services">
    <v-data-table
      :headers="headers"
      :items="indexData.services.data"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">
          {{ props.item.is_active ? "Active" : "In-active" }}
        </td>
        <td class="text-xs-center">{{ props.item.created_by }}</td>
        <td class="text-xs-center">{{ props.item.created_at }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    apiUrl: "service",
    headers: [
      {
        text: "ID",
        align: "center",
        value: "id",
      },
      {
        text: "Service Name",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Active Status",
        align: "center",
        sortable: false,
        value: "is_active",
      },
      {
        text: "Created By",
        align: "center",
        sortable: false,
        value: "created_by",
      },
      {
        text: "Created At",
        align: "center",
        sortable: false,
        value: "created_at",
      },

      { text: "Actions", align: "center", value: "actions" },
    ],
    activeStatus: [
      { name: "Active", id: 1 },
      { name: "In-active", id: 0 },
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      active_status: "",
    },
    defaultItem: {
      name: "",
      active_status: "",
    },
    Rules: {
      required: [(v) => !!v || "This filed is required"],
      serviceActive: [(v) => v>-1 || "This filed is required"],
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Service" : "Edit Service";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.services.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.services.data.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.services.data.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      } else {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      }
      this.close();
    },
  },
};
</script>